import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can log the error to an error reporting service
        console.error('Uncaught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <Container maxWidth="md">
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '60vh',
                            textAlign: 'center',
                            py: 8,
                        }}
                    >
                        <Typography variant="h1" component="h1" gutterBottom>
                            Oops!
                        </Typography>
                        <Typography variant="h4" component="h2" gutterBottom>
                            Something went wrong
                        </Typography>
                        <Typography variant="body1" sx={{ maxWidth: '600px', mb: 4 }}>
                            We're sorry, but an unexpected error occurred. Our team has been notified and we're working to fix it.
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            component={RouterLink}
                            to="/"
                            size="large"
                            onClick={() => this.setState({ hasError: false })}
                        >
                            Try Again
                        </Button>
                    </Box>
                </Container>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;